var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"extra-component-form-validation-demo"}},[_c('ProfileForm'),_c('PasswordForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }